import { render, staticRenderFns } from "./AIPublishJieLong.vue?vue&type=template&id=6b8d9581&scoped=true"
import script from "./AIPublishJieLong.vue?vue&type=script&lang=js"
export * from "./AIPublishJieLong.vue?vue&type=script&lang=js"
import style0 from "./AIPublishJieLong.vue?vue&type=style&index=0&id=6b8d9581&prod&lang=scss&scoped=true"
import style1 from "./AIPublishJieLong.vue?vue&type=style&index=1&id=6b8d9581&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d9581",
  null
  
)

export default component.exports